import { useState, useEffect } from "react";
import { FLAT_SCHEMA, PERMISSIONS_SCHEMA, actionsToState, extractPermissions, parentMap } from "../scripts/configs/PermissionsConfig";
export const RolesNormalizer = (roleMap, users, activeRole=null) => {

    const [roles, setRoles] = useState([]);
    const [checkedRoles, setCheckedRoles] = useState({});

    const getRoleCounts = () => {
        if (!users || users.length === 0) {
            setRoles([]);
            return;
        }

        const roleCounter = {};

        //Only count active users
        const activeUsers = users.filter(user => {
            return user.enabled === true && user.status === "CONFIRMED";
        });

        activeUsers.forEach(user => {
            const department = user.department;

            const roles = department.split(',').map(role => role.trim())
            roles.forEach(roleKey => {
                if (roleKey) {
                    roleCounter[roleKey] = (roleCounter[roleKey] || 0) + 1
                }
            })
        })

        const formattedRoles = Object.keys(roleMap).map(role => {
            const name = roleMap[role];
            // console.log("Name: ", name);
            const count = roleCounter[name] || 0;
            // console.log("Count: ", count)

            return{nombre: role, usuarios: count};
        })

        setRoles(formattedRoles);
        // console.log("Roles after: ", roles);
    }

    useEffect(() => {
        getRoleCounts();
    }, [users, roleMap])
    
    useEffect(() => {
        if (activeRole && activeRole.actions) {
            setCheckedRoles(actionsToState(PERMISSIONS_SCHEMA, activeRole.actions));
        }
    }, [activeRole]);

    //Save the permissions
    const getPermissions = () => extractPermissions(PERMISSIONS_SCHEMA, checkedRoles);

    const handleChange = (name, isChecked, children=[]) => {
        setCheckedRoles(prev => {
            const next = {...prev, [name]: isChecked};
            children.forEach(child => next[child] = isChecked);
            
            let current = name;

            while (parentMap[current]) {
                const parent = parentMap[current];
                const siblings = FLAT_SCHEMA[parent].children;
                next[parent] = siblings.every(sb => next[sb.name]);
                current = parent;
            }
            return next;
        });
    };

    return {roles, checkedRoles, PERMISSIONS_SCHEMA, handleChange, getPermissions}
}
